import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface TupleEntity {
  name: string;
  type: string;
  attributes: Record<string, unknown> | null;
}

export interface Tuple {
  id: string;
  storyId: string;
  storyTitle: string;
  claimType: string;
  subject: TupleEntity;
  predicate: string;
  object: TupleEntity | null;
  value: number | null;
  unit: string | null;
  location: string | null;
  eventDate: string | null;
  sourceCount?: number;
  createdAt: string;
}

interface TuplesResponse {
  tuples: Tuple[];
  total: number;
}

interface UseTuplesOptions {
  limit?: number;
  story?: string;
  type?: string;
  subject?: string;
}

export function useTuples(options: UseTuplesOptions = {}) {
  return useQuery({
    queryKey: ['tuples', options],
    queryFn: () =>
      apiClient.get<TuplesResponse>('/tuples', {
        limit: options.limit || 100,
        story: options.story,
        type: options.type,
        subject: options.subject,
      }),
    refetchInterval: 30000,
  });
}
